import React, { Component } from 'react';
import { Popover, Popconfirm, message, Icon } from 'antd';
import Update from './Update';
import { ApprovalHistory, ContractAttachment, RejectCreateProject } from './PreviewModal';
import ProjectSideNav from '../../projectContract/SideNav';
import ApproveAdvanceWork from './ApproveAdvanceWork';
import ApproveDeliverCode from './ApproveDeliverCode';
import AssistantApproval from './AssistantApproval';
import ExportUtil from '../../../common/ExportUtil';
import TableC from '../../basicElement/TableC';
import MarkContractSign from './MarkContractSign';
import CloseJdeApply from './CloseJdeApply';
import CreateProject from './CreateProject';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import dictCache from '../../../common/dictCache';
import format from '../../shared/format';
import SideNav from '../SideNav';
import Filter from './Filter';
import RelationJde from './RelationJde';
import AdjustAmountModal from './AdjustAmountModal';
import UpdateLog from './UpdateLog';

class ApplyJdeCode extends Component {
    state = {
        loading: false,
        canAdd: false,
        sortParams: {},
        searchParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
        data: [],
        signingUnit: [],
        belongingToUnit: [],
        businessList: [],
    }

    componentDidMount() {
        this.querySigningUnit();
        this.queryBelongingToUnit();
        this.queryWithLevelByParams();
        this.queryDesignatePersonWithUser();
    }

    queryDesignatePersonWithUser = () => {
        const options = {
            method: 'POST',
            url: API_URL.user.queryDesignatePersonWithUser,
            data: {
                type: 'ADD_JDE_APPLY',
            },
            dataType: 'json',
            doneResult: (res) => {
                this.setState({ canAdd: res.isDesignatePerson })
            }
        }
        $.sendRequest(options)
    }

    // 助理审批人员与新增人员(ADD_JDE_APPLY 指定人员)为同一批人 复用 canAdd
    querySigningUnit = () => {
        dictCache.getDict('UNIT_SIGNING', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.contract.queryUnitOfSigningList,
                data: {
                    offset: 1,
                    limit: 999,
                },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { datas = [] } = res;
            this.setState({ signingUnit: datas });
        });
    }

    queryBelongingToUnit = () => {
        dictCache.getDict('UNIT_BELONGING', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.contract.queryUnitOfBelongingList,
                data: {
                    offset: 1,
                    limit: 999,
                },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { datas = [] } = res;
            this.setState({ belongingToUnit: datas });
        });
    }

    queryWithLevelByParams = () => {
        dictCache.getDict('LINE_OF_BUSINESS', cb => {
            $.sendRequest({
                method: 'POST',
                url: API_URL.common.queryWithLevelByParams,
                data: { typeName: 'LINE_OF_BUSINESS' },
                dataType: 'json',
                doneResult: res => cb(res),
            });
        }, res => {
            const { typeConfigureList } = res;
            this.setState({ businessList: typeConfigureList || [] });
        });
    }

    loadData = () => {
        const { sortParams, searchParams, pagination, pagination: { current, pageSize } } = this.state;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.queryJdeApplyList,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
                ...sortParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [], totalCount } = res;
                pagination.total = totalCount;
                this.setState({
                    loading: false,
                    data: datas,
                    pagination,
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    search = params => {
        const { pagination } = this.state;
        pagination.current = 1;
        this.setState({
            searchParams: { ...params },
            pagination
        }, () => {
            this.loadData();
        });
    }

    delete = (jdeApplyId) => {
        const options = {
            method: 'POST',
            url: API_URL.contract.deleteJdeApply,
            data: { jdeApplyId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.setState({ loading: false }, () => {
                    this.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    export = () => {
        const { sortParams, searchParams } = this.state;
        const url = API_URL.contract.exportJdeApplyList;
        ExportUtil.export({ ...sortParams, ...searchParams }, null, url);
    }

    queryIsSetPM = (record) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.checkProjectPM,
            data: {
                jdeApplyId: record.jdeApplyId
            },
            dataType: 'json',
            doneResult: () => {
                this.setState({ loading: false }, () => {
                    this.showMarkContractSign(record);
                })
            },
            errorResult: () => {
                this.setState({ loading: false });
            },
        };
        $.sendRequest(options);
    }

    canEditByInvStatus = (investigationId, callback) => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.investigation.queryInvestigationStageByInvId,
            data: { investigationId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const canEdit = !(data || []).some(i => {
                    if (i.operation === 'INVESTIGATION_DATA_LOCK') {
                        message.error('项目到达"项目关闭"阶段，不可调整项目相关数据！');
                        return true;
                    } else if (i.operation === 'TERMINATED_BEFORE_CONTRACT') {
                        message.error('项目已在服务合同签署前终止，不可调整项目相关数据');
                        return true;
                    }
                    return false;
                });
                this.setState({ loading: false }, () => {
                    if (canEdit) {
                        callback();
                    }
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: '申请编号',
        dataIndex: 'jdeApplyCode',
        key: 'jdeApplyCode',
        fixed: 'left',
        sorter: true,
        width: 100,
        render: (text, record) => {
            const { redFlag = false } = record;
            return <span style={{ color: redFlag ? 'red' : undefined }}>{text}</span>
        }
    // 冻结前4列: 申请编号/需求ID/需求类型/项目类型
    }, {
        title: '需求ID',
        dataIndex: 'crmRequirementId',
        key: 'crmRequirementId',
        fixed: 'left',
        width: 100,
    }, {
        title: '需求类型',
        dataIndex: 'requirementType',
        key: 'requirementType',
        fixed: 'left',
        width: 100,
    }, {
        title: '项目类型',
        dataIndex: 'investigationTypeName',
        key: 'investigationTypeName',
        fixed: 'left',
        width: 120,
    }, {
        title: '业务类型',
        dataIndex: 'businessType',
        key: 'businessType',
        width: 100,
    }, {
        title: '合同签署方',
        dataIndex: 'contractSignCompanyName',
        key: 'contractSignCompanyName',
        width: 100,
    }, {
        title: '项目识别码',
        dataIndex: 'investigationIdentifyCode',
        key: 'investigationIdentifyCode',
        width: 100,
    }, {
        title: '项目编号',
        dataIndex: 'customerProjectCode',
        key: 'customerProjectCode',
        width: 100,
    }, {
        title: '系统中是否有此项目',
        dataIndex: 'jdeApplyIsInvestigationExistsShow',
        key: 'jdeApplyIsInvestigationExistsShow',
        width: 80,
    }, {
        title: '项目简称',
        dataIndex: 'investigationName',
        key: 'investigationName',
        width: 120,
    }, {
        title: '领域leader',
        dataIndex: 'leaderNameCode',
        key: 'leaderNameCode',
        width: 120,
    }, {
        title: '此项目是否为临床项目',
        dataIndex: 'isClinicalProjectShow',
        key: 'isClinicalProjectShow',
        width: 80,
    }, {
        title: '业务机会编号',
        dataIndex: 'businessOpportunityNum',
        key: 'businessOpportunityNum',
        width: 120,
    }, {
        title: '临床评估单号',
        dataIndex: 'evaluateCode',
        key: 'evaluateCode',
        width: 100,
    }, {
        title: 'JDE主项目号',
        dataIndex: 'jdeCode',
        key: 'jdeCode',
        width: 100,
    }, {
        title: '合同或函证是否签署',
        dataIndex: 'contractOrLetterIsSignShow',
        key: 'contractOrLetterIsSignShow',
        width: 80,
    }, {
        title: '合同性质',
        dataIndex: 'natureOfContractShow',
        key: 'natureOfContractShow',
        width: 80,
    }, {
        title: '关联JDE',
        dataIndex: 'relationJdeCode',
        key: 'relationJdeCode',
        width: 120,
        render: (text, record, index) => {
            const { relateJdeIsDeductAmountShow } = record;
            return relateJdeIsDeductAmountShow == '是' ? <a onClick={() => this.relationJdeShow(record)}>{text}</a> : text
        }
    }, {
        title: '客户全名',
        dataIndex: 'customerCompanyName',
        key: 'customerCompanyName',
        width: 100,
    }, {
        title: '客户JDE号',
        dataIndex: 'customerJdeCode',
        key: 'customerJdeCode',
        width: 100,
    }, {
        title: '客户项目号',
        dataIndex: 'customerInvCode',
        key: 'customerInvCode',
        width: 100,
    }, {
        title: 'BA',
        dataIndex: 'ba',
        key: 'ba',
        width: 100,
        render: (text, record) => {
            const { baName, baCode } = record;
            return format('joint', baName, baCode);
        }
    }, {
        title: '业务线',
        dataIndex: 'lineOfBusinessString',
        key: 'lineOfBusinessString',
        width: 80,
    }, {
        title: '执行业务线二级分类',
        dataIndex: 'secondLineNames',
        key: 'secondLineNames',
        width: 100,
    }, {
        title: '类别码15',
        dataIndex: 'categoryCodeName15',
        key: 'categoryCodeName15',
        width: 80,
    }, {
        title: '合同签署单位',
        dataIndex: 'signingUnit',
        key: 'signingUnit',
        width: 100,
    }, {
        title: '收入归属单位',
        dataIndex: 'belongingToUnit',
        key: 'belongingToUnit',
        width: 100,
    }, {
        title: '备注',
        dataIndex: 'contractRelationSiteComment',
        key: 'contractRelationSiteComment',
        width: 100,
    }, {
        title: '币种',
        dataIndex: 'currency',
        key: 'currency',
        width: 100,
    }, {
        title: '汇率',
        dataIndex: 'exchangeRate',
        key: 'exchangeRate',
        width: 80,
    }, {
        title: '预计合同金额/原币',
        dataIndex: 'initialExpectContractAmount',
        key: 'initialExpectContractAmount',
        width: 120,
        render: (text, record) => {
            const { currency, jdeApplyStatusShow, contractOrLetterIsSignShow } = record;
            const isCNY = currency == '人民币(CNY)';

            // 检查状态，如果是这些状态之一，则不显示编辑按钮
            const isEditDisabled = jdeApplyStatusShow === '未签署合同申请已关闭' ||
                jdeApplyStatusShow === 'JDE建号申请已关闭' ||
                jdeApplyStatusShow === '已标记合同签署完成' ||
                contractOrLetterIsSignShow === '是';

            if (isCNY) {
                return format('money', text);
            }

            if (isEditDisabled) {
                return format('money', text);
            }

            return <div
                style={{ position: 'relative' }}
                onMouseEnter={(e) => {
                    const cell = e.currentTarget;
                    const icon = cell.querySelector('.edit-icon');
                    if (icon) {
                        icon.style.display = 'inline-block';
                    }
                }}
                onMouseLeave={(e) => {
                    const cell = e.currentTarget;
                    const icon = cell.querySelector('.edit-icon');
                    if (icon) {
                        icon.style.display = 'none';
                    }
                }}
            >
                <span style={{ marginRight: 10 }}>
                    {format('money', text)}
                </span>
                <a
                    className="edit-icon"
                    style={{
                        position: 'absolute',
                        right: 0,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        display: 'none'
                    }}
                >
                    <Icon
                        type="edit"
                        onClick={() => this.showAdjustModal(record)}
                    />
                </a>
            </div>
        }
    }, {
        title: '预计合同金额/人民币（元）',
        dataIndex: 'expectContractAmount',
        key: 'expectContractAmount',
        width: 120,
        render: (text, record) => {
            const { currency, jdeApplyStatusShow, contractOrLetterIsSignShow } = record;
            const isCNY = currency == '人民币(CNY)';

            // 检查状态，如果是这些状态之一，则不显示编辑按钮
            const isEditDisabled = jdeApplyStatusShow === '未签署合同申请已关闭' ||
                jdeApplyStatusShow === 'JDE建号申请已关闭' ||
                jdeApplyStatusShow === '已标记合同签署完成' ||
                contractOrLetterIsSignShow === '是';

            if (!isCNY) {
                return format('money', text);
            }

            if (isEditDisabled) {
                return format('money', text);
            }

            return <div
                style={{ position: 'relative' }}
                onMouseEnter={(e) => {
                    const cell = e.currentTarget;
                    const icon = cell.querySelector('.edit-icon');
                    if (icon) {
                        icon.style.display = 'inline-block';
                    }
                }}
                onMouseLeave={(e) => {
                    const cell = e.currentTarget;
                    const icon = cell.querySelector('.edit-icon');
                    if (icon) {
                        icon.style.display = 'none';
                    }
                }}
            >
                <span style={{ marginRight: 10 }}>
                    {format('money', text)}
                </span>
                <a
                    className="edit-icon"
                    style={{
                        position: 'absolute',
                        right: 0,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        display: 'none'
                    }}
                >
                    <Icon
                        type="edit"
                        onClick={() => this.showAdjustModal(record)}
                    />
                </a>
            </div>
        }
    }, {
        title: '合同中是否明标合同金额',
        dataIndex: 'contractIsSpecifiesAmountShow',
        key: 'contractIsSpecifiesAmountShow',
        width: 100,
    }, {
        title: '合同额含税/原币',
        dataIndex: 'initialContractAmount',
        key: 'initialContractAmount',
        width: 100,
        render: (text, record) => {
            const { initialActualExpenseFee, initialTaxationFee, initialActualFee } = record;
            if (initialActualExpenseFee || initialActualExpenseFee === 0 || initialActualFee || initialActualFee === 0 || initialTaxationFee || initialTaxationFee === 0) {
                return (
                    <Popover
                        placement="right"
                        overlayClassName="gray-pop"
                        content={<div>
                            {(initialActualExpenseFee || initialActualExpenseFee === 0) && <span>{`实报实销(不含税)/原币: ${format('money', initialActualExpenseFee)}`}<br /></span>}
                            {(initialActualFee || initialActualFee === 0) && <span>{`实报实销税费/原币: ${format('money', initialActualFee)}`}<br /></span>}
                            {(initialTaxationFee || initialTaxationFee === 0) && <span>{`合同额税费/原币: ${format('money', initialTaxationFee)}`}<br /></span>}
                        </div>}
                        trigger="hover"
                    >
                        <div>
                            <i className='pop' style={{ cursor: 'pointer' }}></i>
                            {format('money', text)}
                        </div>
                    </Popover>
                );
            } else {
                return format('money', text);
            }
        },
    }, {
        title: '合同额含税/人民币（元）',
        dataIndex: 'contractAmount',
        key: 'contractAmount',
        width: 100,
        render: (text, record) => {
            const { actualExpenseFee, taxationFee, actualFee } = record;
            if (actualExpenseFee || actualExpenseFee === 0 || actualFee || actualFee === 0 || taxationFee || taxationFee === 0) {
                return (
                    <Popover
                        placement="right"
                        overlayClassName="gray-pop"
                        content={<div>
                            {(actualExpenseFee || actualExpenseFee === 0) && <span>{`实报实销(不含税)/人民币: ${format('money', actualExpenseFee)}`}<br /></span>}
                            {(actualFee || actualFee === 0) && <span>{`实报实销税费/人民币: ${format('money', actualFee)}`}<br /></span>}
                            {(taxationFee || taxationFee === 0) && <span>{`合同额税费/人民币: ${format('money', taxationFee)}`}<br /></span>}
                        </div>}
                        trigger="hover"
                    >
                        <div>
                            <i className='pop' style={{ cursor: 'pointer' }}></i>
                            {format('money', text)}
                        </div>
                    </Popover>
                );
            } else {
                return format('money', text);
            }
        },
    }, {
        title: '合同税率',
        dataIndex: 'rate',
        key: 'rate',
        width: 80,
        render: text => format('unit', text, '%'),
    }, {
        title: '关联JDE是否需要扣除相应金额',
        dataIndex: 'relateJdeIsDeductAmountShow',
        key: 'relateJdeIsDeductAmountShow',
        width: 120,
    }, {
        title: '是否据实结算',
        dataIndex: 'realitySettleShow',
        key: 'realitySettleShow',
        width: 100,
    }, {
        title: '客户是否MSA特殊优惠客户',
        dataIndex: 'msaSpecialDiscountCustomShow',
        key: 'msaSpecialDiscountCustomShow',
        width: 100,
    }, {
        title: '是否在优惠有效期内',
        dataIndex: 'discountTermValidityShow',
        key: 'discountTermValidityShow',
        width: 100,
    }, {
        title: 'MSA特殊优惠是否从合同额中扣减',
        dataIndex: 'msaSpecialContractReduceShow',
        key: 'msaSpecialContractReduceShow',
        width: 100,
    }, {
        title: '优惠金额（含税）/人民币',
        dataIndex: 'discountContractAmount',
        key: 'discountContractAmount',
        width: 100,
        render: text => format('money', text),
    }, {
        title: '优惠金额（不含税）/人民币',
        dataIndex: 'discountContractAmountNoTax',
        key: 'discountContractAmountNoTax',
        width: 100,
        render: text => format('money', text),
    }, {
        title: '合同开始时间',
        dataIndex: 'contractStartDateShow',
        key: 'contractStartDateShow',
        width: 100,
    }, {
        title: '合同结束时间',
        dataIndex: 'contractEndDateShow',
        key: 'contractEndDateShow',
        width: 100,
    }, {
        title: '申请人姓名',
        dataIndex: 'createUserName',
        key: 'createUserName',
        width: 100,
    }, {
        title: '申请时间',
        dataIndex: 'jdeApplyDateShow',
        key: 'jdeApplyDateShow',
        width: 100,
    }, {
        title: '申请状态',
        dataIndex: 'jdeApplyStatusShow',
        key: 'jdeApplyStatusShow',
        width: 120,
    }, {
        title: 'JDE项目号',
        dataIndex: 'investigationJdeCode',
        key: 'investigationJdeCode',
        width: 100,
    }, {
        title: '发号时间',
        dataIndex: 'distributeTimeShow',
        key: 'distributeTimeShow',
        width: 100,
    }, {
        title: 'FIN审核合同金额通过时间',
        dataIndex: 'finAgreeDateShow',
        key: 'finAgreeDateShow',
        width: 100,
    }, {
        title: '计收入确认方式',
        dataIndex: 'contractTypeValue',
        key: 'contractTypeValue',
        width: 100
    }, {
        title: '发票税率',
        dataIndex: 'invoiceRate',
        key: 'invoiceRate',
        width: 80,
        render: text => format('unit', text, '%'),
    }, {
        title: '是否拥有纸质合同',
        dataIndex: 'havePaperContractShow',
        key: 'havePaperContractShow',
        width: 100
    }, {
        title: '操作',
        dataIndex: 'operate',
        key: 'operate',
        fixed: 'right',
        width: 160,
        render: (text, record, index) => {
            const { curRole, userId } = sessionStorage;
            const { jdeApplyId, createUserId, jdeApplySceneId, haveResult, jdeApplyStatusShow, contractOrLetterIsSign, canCopyNew, investigationId, mainPmUserId, curUserIsPm, canApprovalAdvanceDuty, jdeApplyStatus } = record;
            const { canAdd } = this.state;
            const contractIsSign = contractOrLetterIsSign == '1';
            const isNewCreate = haveResult == 'false';
            const comDom = (
                <span>
                    <a onClick={() => this.showContractAttachment(record)}>查看附件</a>
                    <span className="ant-divider" />
                    <a onClick={() => this.showApprovalHistory(record)}>操作日志</a>
                    {
                        canAdd && jdeApplyStatus === 'ASSISTANT_APPROVAL' &&
                        <span>
                            <span className="ant-divider" />
                            <a onClick={() => this.showAssistantApproval(record)}>助理审批</a>
                        </span>
                    }
                    {
                        !!record.expectContractAmount &&
                        <span>
                            <span className="ant-divider" />
                            <a onClick={() => this.showUpdateLog(record)}>更新日志</a>
                        </span>
                    }
                    {
                        record.canPrincipalCreateInvestigation &&
                        <span>
                            <span className="ant-divider" />
                            {
                                record.jdeApplySceneId == 1 &&
                                <a onClick={() => this.showApproveAdvanceWork(record, 'approval')}>待负责人审批新建项目</a>
                            }
                            {
                                record.jdeApplySceneId == 2 &&
                                <a onClick={() => this.showApproveAdvanceWork(record, 'approvalSecond')}>待负责人审批新建项目</a>
                            }
                        </span>
                    }
                    {
                        record.canCloseJdeApply &&
                        <span>
                            <span className="ant-divider" />
                            <a onClick={() => this.showCloseJdeApply(record, 'jdeApply')}>关闭JDE建号申请</a>
                        </span>
                    }
                    {
                        record.approvalCloseJdeApply &&
                        <span>
                            <span className="ant-divider" />
                            <a onClick={() => this.showCloseJdeApply(record, 'jdeApprove')}>审批关闭申请</a>
                        </span>
                    }
                    {
                        record.canCloseNoSignedJdeApply &&
                        <span>
                            <span className="ant-divider" />
                            <a onClick={() => this.showCloseJdeApply(record, 'apply')}>未签署合同关闭申请</a>
                        </span>
                    }
                    {
                        record.approvalCloseNoSignedJdeApply &&
                        <span>
                            <span className="ant-divider" />
                            <a onClick={() => this.showCloseJdeApply(record, 'approve')}>审批未签署合同关闭申请</a>
                        </span>
                    }
                </span>
            );
            if (canAdd) {
                return (
                    <span>
                        {
                            (curRole !== 'BDM' || userId == createUserId) &&
                            <span>
                                {
                                    ((jdeApplyStatusShow == '待VP审批提前上岗' && isNewCreate)
                                        || jdeApplyStatusShow == '提前上岗审批不通过'
                                        || jdeApplyStatusShow == '打回创建项目'
                                        || jdeApplyStatusShow == 'JDE号审批不通过'
                                        || jdeApplyStatusShow == 'CTA审核合同金额不通过'
                                        || jdeApplyStatusShow == 'FIN审核合同金额不通过'
                                        || jdeApplyStatusShow == 'PM审核合同金额不通过'
                                        || jdeApplyStatusShow == '负责人审批新建项目不通过'
                                        || jdeApplyStatusShow == '待负责人审批新建项目' && isNewCreate && jdeApplySceneId == 2
                                        || (jdeApplyStatusShow == '待PM审核合同金额' && isNewCreate && (jdeApplySceneId == 8 || jdeApplySceneId == 9))
                                        || (jdeApplyStatusShow == '待CTA审核合同金额' && isNewCreate && jdeApplySceneId == 5)
                                        || (jdeApplyStatusShow == '待FIN审批JDE号' && isNewCreate && (jdeApplySceneId == 3 || jdeApplySceneId == 6))
                                        || jdeApplyStatusShow == '待助理审批') ?
                                        <a onClick={() => this.updateApplyJdeCode(record, 'edit')}>修改</a>
                                        :
                                        <a disabled={true}>修改</a>
                                }
                                <span className="ant-divider" />
                            </span>
                        }
                        {
                            (curRole !== 'BDM' || userId == createUserId) && (
                                (jdeApplyStatusShow == '待VP审批提前上岗'
                                    || jdeApplyStatusShow == '打回创建项目'
                                    || (jdeApplyStatusShow == '待负责人审批新建项目' && jdeApplySceneId == 2)
                                    || (jdeApplyStatusShow == '待CTA新建项目' && jdeApplySceneId == 2)
                                    || (jdeApplyStatusShow == '待PM审核合同金额' && (jdeApplySceneId == 8 || jdeApplySceneId == 9))
                                    || (jdeApplyStatusShow == '待CTA审核合同金额' && jdeApplySceneId == 5)
                                    || (jdeApplyStatusShow == '待FIN审批JDE号' && (jdeApplySceneId == 3 || jdeApplySceneId == 6)))
                                && isNewCreate &&
                                <span>
                                    <Popconfirm title="确定要撤销吗?" onConfirm={() => this.delete(jdeApplyId)}>
                                        <a>撤销</a>
                                    </Popconfirm>
                                    <span className="ant-divider" />
                                </span>
                            )
                        }
                        {
                            (curRole !== 'BDM' || userId == createUserId) &&
                            <span>
                                {
                                    ((jdeApplyStatusShow == 'JDE号已发放' || jdeApplyStatusShow == 'BO审批关闭申请不通过' || jdeApplyStatusShow == 'PM审批关闭申请不通过' || jdeApplyStatusShow == 'VP审批关闭申请不通过') && !contractIsSign) ?
                                        <a onClick={() => this.queryIsSetPM(record)}>标记合同签署</a>
                                        :
                                        <a disabled={true}>标记合同签署</a>
                                }
                                <span className="ant-divider" />
                            </span>
                        }
                        {comDom}
                        {
                            (curRole !== 'BDM' || userId == createUserId) &&
                            canCopyNew && jdeApplyStatusShow !== '待CTA新建项目' &&
                            <span>
                                <span className="ant-divider" />
                                <a onClick={() => this.updateApplyJdeCode(record, 'copy')}>复制新建</a>
                            </span>
                        }
                    </span>
                );
            } else if (curRole == 'CTA') {
                return (
                    <span>
                        {
                            jdeApplyStatusShow == '待CTA新建项目' &&
                            <span>
                                <a onClick={() => this.showCreateProject(record, 'create')}>创建项目</a>
                                <span className="ant-divider" />
                                <a onClick={() => this.rejectCreateProject(record)}>拒绝创建</a>
                                <span className="ant-divider" />
                                <a onClick={() => this.showCreateProject(record, 'return')}>打回</a>
                                <span className="ant-divider" />
                            </span>
                        }
                        {
                            jdeApplyStatusShow == '待CTA审核合同金额' &&
                            <span>
                                <a onClick={() => this.canEditByInvStatus(investigationId, () => this.showMarkContractSign(record))}>审核金额</a>
                                <span className="ant-divider" />
                            </span>
                        }
                        {comDom}
                    </span>
                );
            } else if (curRole == 'PM' || curRole == 'PML' || ((curRole == 'CRC' || curRole == 'CRCC' || curRole == 'CRCM') && curUserIsPm)) {
                return (
                    <span>
                        {
                            (jdeApplyStatusShow == '待PM审核合同金额') && (mainPmUserId == userId) &&
                            <span>
                                <a onClick={() => this.canEditByInvStatus(investigationId, () => this.showMarkContractSign(record))}>审核金额</a>
                                <span className="ant-divider" />
                            </span>
                        }
                        {comDom}
                    </span>
                );
            } else if (curRole == 'FIN') {
                return (
                    <span>
                        {
                            jdeApplyStatusShow == '待FIN审批JDE号' ?
                                <span>
                                    <a onClick={() => this.canEditByInvStatus(investigationId, () => this.showApproveDeliverCode(record))}>审批发号</a>
                                    <span className="ant-divider" />
                                </span>
                                :
                                jdeApplyStatusShow == '待FIN审核合同金额' ?
                                    <span>
                                        <a onClick={() => this.canEditByInvStatus(investigationId, () => this.showMarkContractSign(record))}>审核金额</a>
                                        <span className="ant-divider" />
                                    </span>
                                    :
                                    null
                        }
                        {comDom}
                    </span>
                );
            } else if (curRole == 'VP') {
                return (
                    <span>
                        {
                            jdeApplyStatusShow == '待VP审批提前上岗' &&
                            <span>
                                {/* <a onClick={() => this.canEditByInvStatus(investigationId, () => this.showApproveAdvanceWork(record, 'VPApproval'))}>审批</a> */}
                                <a onClick={() => this.showApproveAdvanceWork(record, 'VPApproval')}>审批</a>
                                <span className="ant-divider" />
                            </span>
                        }
                        {comDom}
                    </span>
                );
            } else if (canApprovalAdvanceDuty) {
                return (
                    <span>
                        {
                            jdeApplyStatusShow == '待VP审批提前上岗' &&
                            <span>
                                <a onClick={() => this.showApproveAdvanceWork(record, 'VPApproval')}>审批</a>
                                <span className="ant-divider" />
                            </span>
                        }
                        {comDom}
                    </span>
                );
            }
            return comDom;
        }
    }]

    getDataSource = () => {
        const { data } = this.state;
        const dataSource = data.map(item => ({ ...item }));
        return dataSource;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    updateApplyJdeCode = (record, type) => {
        this.updateRef.show(record, type);
    }

    showApprovalHistory = (record) => {
        this.approvalHistoryRef.show(record);
    }

    showAssistantApproval = (record) => {
        this.assistantApprovalRef.show(record);
    }

    showContractAttachment = (record) => {
        this.contractAttachmentRef.show(record);
    }

    showApproveAdvanceWork = (record, type) => {
        this.approveAdvanceWorkRef.show(record, type);
    }

    showCreateProject = (record, type) => {
        this.createProjectRef.show(record, type);
    }

    relationJdeShow = record => {
        this.relationJdeRef.show(record);
    }

    showAdjustModal = record => {
        this.adjustAmountModalRef.show(record);
    }

    showUpdateLog = record => {
        this.updateLogRef.show(record);
    }

    rejectCreateProject = (record) => {
        this.rejectCreateProjectRef.show(record);
    }

    showApproveDeliverCode = (record) => {
        this.approveDeliverCodeRef.show(record);
    }

    showMarkContractSign = (record) => {
        this.markContractSignRef.show(record);
    }

    showCloseJdeApply = (record, type) => {
        this.closeJdeApplyRef.show(record, type);
    }

    render() {
        const { loading, pagination, sortParams, businessList, signingUnit, belongingToUnit, canAdd } = this.state;
        const { invState } = sessionStorage;
        return (
            <div className="content">
                {
                    invState == 1 ?
                        <ProjectSideNav selectKey='applyJdeCode' />
                        :
                        <SideNav selectKey='applyJdeCode' />
                }
                <div className="main">
                    <Filter
                        search={this.search}
                        export={this.export}
                        canAdd={canAdd}
                        businessList={businessList}
                        signingUnitList={signingUnit}
                        belongingToUnitList={belongingToUnit}
                        updateApplyJdeCode={this.updateApplyJdeCode}
                        {...this.props}
                    />
                    <TableC
                        loading={loading}
                        scrollY={550}
                        sortParams={sortParams}
                        pagination={pagination}
                        columns={this.getColumns()}
                        data={this.getDataSource()}
                        onChange={this.handleTableChange}
                    />
                    <ContractAttachment ref={el => this.contractAttachmentRef = el} />
                    <ApprovalHistory ref={el => this.approvalHistoryRef = el} />
                    <AssistantApproval ref={el => this.assistantApprovalRef = el} loadData={this.loadData} />
                    <CreateProject ref={el => this.createProjectRef = el} businessList={businessList} loadData={this.loadData} />
                    <ApproveAdvanceWork ref={el => this.approveAdvanceWorkRef = el} businessList={businessList} loadData={this.loadData} />
                    <MarkContractSign
                        ref={el => this.markContractSignRef = el}
                        loadData={this.loadData}
                        businessList={businessList}
                        signingUnitList={signingUnit}
                        relationJdeShow={this.relationJdeShow}
                        belongingToUnitList={belongingToUnit}
                    />
                    <CloseJdeApply
                        ref={el => this.closeJdeApplyRef = el}
                        loadData={this.loadData}
                        businessList={businessList}
                        signingUnitList={signingUnit}
                        belongingToUnitList={belongingToUnit}
                    />
                    <ApproveDeliverCode
                        ref={el => this.approveDeliverCodeRef = el}
                        loadData={this.loadData}
                        businessList={businessList}
                        signingUnitList={signingUnit}
                        belongingToUnitList={belongingToUnit}
                    />
                    <Update
                        ref={el => this.updateRef = el}
                        loadData={this.loadData}
                        businessList={businessList}
                        signingUnitList={signingUnit}
                    />
                    <RejectCreateProject ref={el => this.rejectCreateProjectRef = el} loadData={this.loadData} />
                    <RelationJde ref={el => this.relationJdeRef = el} showContractAttachment={this.showContractAttachment} />
                    <AdjustAmountModal ref={el => this.adjustAmountModalRef = el} loadData={this.loadData} />
                    <UpdateLog ref={el => this.updateLogRef = el} />
                </div>
            </div>
        );
    }
}

export default ApplyJdeCode;


// WEBPACK FOOTER //
// ./src/components/contractManagement/ApplyJdeCode/index.js